import {useQuery} from "@tanstack/react-query";

import {fetchRoles, fetchRolesByOwner} from "../../services/network/role-api";
import {RECOMMENDATION_ENDPOINTS, ROLE_ENDPOINTS} from "../../services/network/endpoints";
import {RecommendationsApi} from "../../services/network/recommendation-api";

export function useFetchRecommsShort() {
    const {data, error, isLoading} = useQuery({
        queryKey: [RECOMMENDATION_ENDPOINTS.FETCH_SHORT],
        queryFn: () => RecommendationsApi.fetchRecommendationsShort(),
    });

    return {
        recommsShortData: data?.data,
        recommsShortError: error,
        recommsShortIsLoading: isLoading,
    };
}
